export default {
  widgets: [
    'families', 'populations', 'estimates'
  ],
  widgetData: [],
  populations: {
    data: [],
    loading: true
  },
  trends: {
    data: [],
    loading: true
  },
  trend_categories: {
    data: [],
    loading: true
  },
  filters: {
    family_id: [],
    publication_id: 0,
    framework_id: [],
    flyway_region_id: [],
    ramsar_region_id: [],
    red_list_id: []
  },
};
